#import "./PurchaseOrderListFields.graphql"

query PurchaseOrder($id: UUID!) {
  purchaseOrder(id: $id) {
    ...PurchaseOrderListFields
  }
}
